import VegIcon from "./VegIcon";

export interface OrderItem {
  id: string;
  code: string | number;
  name: string;
  qty: number;
  price: number;
  type: "veg" | "nonveg";
  orderedAt: string;
  served: boolean;
  currency?: string;
}

interface Props {
  item: OrderItem;
  // onToggleServed?: (item: OrderItem) => void;
}

// const CheckMark = () => (
//   <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
//     <path d="M5 12l5 5L20 7" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
//   </svg>
// );

const OrderItemCard = ({ item }: Props) => {
  const currency = item.currency ?? "₹";

  return (
    <article className="bg-white rounded-[6px] border border-[#E6EEFF] p-3 flex flex-col gap-1.5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1.5">
          <VegIcon type={item.type} size={18} />
          <h3 className="font-sansation font-bold text-[#111] text-[16px]">
            Dish Code : {item.code}
          </h3>
        </div>

      </div>

      <p className="font-opensans text-[16px] text-[rgba(17,17,17,0.8)]">  {item.name} </p>
      <p className="font-opensans text-[12px] text-[#111]">Qty- {item.qty}</p>
      <div className="flex items-end justify-between mt-1">
        <p className="font-sansation font-bold text-[#F15A29] text-[16px]">
          {currency} {(item.price * item.qty).toFixed(2)}
        </p>
        <p className="font-opensans text-[12px] text-[rgba(17,17,17,0.6)]">
          Ordered at {item.orderedAt}
        </p>
      </div>
    </article>
  );
};

export default OrderItemCard;
